import React from 'react';
import Plus from '@tradera/blueprint/theme/icons2/plus.svg?jsx';

const AttributeButton = ({ className, text, onClick }) => {
    return (
        <button
            className={`btn btn-outline-dark btn-sm btn--icon-hidden ${className ||
                ''}`}
            onClick={onClick}>
            <Plus className="icon mr-2" />
            <span className="btn-inner">{text}</span>
        </button>
    );
};
export default AttributeButton;
